<template>
  <div class="container">
    <img src="@/assets/images/gxqgouche2212/download.jpg" alt="" />
    <div class="download">
      <div class="download-btn" @click="handleDownload">下载数字人民币App</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',
  data() {
    return {}
  },
  mounted() {},
  methods: {
    handleDownload() {
      window.location.href = 'https://pilot.app.ecny.pbcdci.cn/download/index.html'
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  min-height 100%
  overflow-y scroll
  background #ff402f
  padding-bottom 80px
  .download
    position relative
    padding 0 60px
    .download-btn
      position absolute
      bottom -40px
      background #ffb84e
      width 650px
      height 80px
      color #ffffff
      line-height 80px
      border-radius 50px
      text-align center
      font-size 30px
      font-weight bold
</style>
